import React, {useCallback, useMemo} from 'react'
import {useTranslation} from 'react-i18next'

import {BottomSheet} from 'src/designSystem/components/atoms/BottomSheet/BottomSheet'
import {SubscriptionLegalize} from 'src/products/loans/LoanApprovedActivation/Advance/AcceptSubscriptionAgreement/SubscriptionLegalize'

export type MembershipAgreementBottomSheetProps = {
  visible: boolean
  onDismiss: () => Promise<void>
  onSetSelected: (value: boolean) => void
  loanId: string
  isSelected: boolean
  onCloseBottomSheet: () => void
  isResumeMembershipLoading?: boolean
}

const MembershipAgreementBottomSheet: React.FC<MembershipAgreementBottomSheetProps> = ({
  visible,
  onDismiss: handleOnDismiss,
  onSetSelected: handleOnSetSelected,
  loanId,
  isSelected,
  onCloseBottomSheet,
  isResumeMembershipLoading,
}) => {
  const {t} = useTranslation('DashboardMembershipApprovedTile')

  const handleCloseBottomSheet = useCallback(() => {
    onCloseBottomSheet()
  }, [onCloseBottomSheet])

  const dismissButton = useMemo(
    () => ({
      text: t('AcceptAndContinue'),
      testID: 'Membership-Approved-Tile-Accept-Agreement-Button',
      disabled: !isSelected || isResumeMembershipLoading,
      loading: isResumeMembershipLoading,
    }),
    [t, isSelected, isResumeMembershipLoading],
  )

  return (
    <BottomSheet
      visible={visible}
      onDismiss={handleOnDismiss}
      dismissButton={dismissButton}
      showCloseButton
      closeButtonAction={onCloseBottomSheet}
      title={t('AcceptMembershipAgreement')}
      titleVariant={'h3'}
      titleAlign={'left'}
      showDots={false}
      testID="Accept-Membership-Agreement"
    >
      <SubscriptionLegalize
        onSetSelected={handleOnSetSelected}
        loanId={loanId}
        onCloseBottomSheet={handleCloseBottomSheet}
      />
    </BottomSheet>
  )
}

export {MembershipAgreementBottomSheet}
